export default function AccessDeniedError() {
  return (
    <div className="flex size-full items-center justify-center">
      <div className="w-full max-w-[560px] select-none text-center">
        <div className="mx-auto flex size-[160px] items-center justify-center rounded-full bg-red-50">
          <span className="text-[80px]">🚫</span>
        </div>
        <h2 className="my-4 text-2xl font-bold text-destructive">
          No diste permisos para acceder a TUNI
        </h2>
        <p className="flex flex-col text-lg text-gray-600">
          <span>Necesitamos que aceptes los permisos para acceder.</span>
          <span>Por favor, refrescá la página y aceptá los permisos para continuar.</span>
        </p>
      </div>
    </div>
  )
}
